import { useQuery } from '@tanstack/react-query';

import { tasksApi } from '../api';
import { TaskDataWeeklyTrendWithData } from '@demind-inc/core';

interface UseTaskTrendParams {
  dataTrendId: string;
  startDate: string;
  endDate: string;
  enabled?: boolean;
}

interface UseTaskWeeklyTrendQueryParams {
  queryKey: ['lifestack.trend.task.weekly', UseTaskTrendParams];
}

export const useTaskWeeklyTrend = ({
  dataTrendId,
  startDate,
  endDate,
  enabled = true,
}: UseTaskTrendParams) => {
  const taskTrendQuery = useQuery({
    queryKey: ['lifestack.trend.task.weekly', { dataTrendId, startDate, endDate }],
    queryFn: ({ queryKey }: UseTaskWeeklyTrendQueryParams) => {
      const [, { dataTrendId, startDate, endDate }] = queryKey;
      return tasksApi
        .getWeeklyTasksTrendV2(dataTrendId, startDate, endDate)
        .then(({ data }) => data as TaskDataWeeklyTrendWithData);
    },
    refetchOnWindowFocus: false,
    staleTime: 15000, // 15s
    enabled: !!dataTrendId && enabled,
  });

  return {
    taskTrend: taskTrendQuery.data,
    ...taskTrendQuery,
  };
};
